import React, { useState } from 'react';
import DateRangePicker from 'components/Atom/DateRange';
import { Button } from 'components/Atom/Button';
import moment from 'moment';
import { Form, notification } from 'antd';
const Filter = ({ filtersData, handleClose, onSearch, filterToggler }) => {
  const [filterData, setFilterData] = useState(filtersData);
  const handleOnChangeValue = (e, type) => {
    if (e === null || e === 'all') {
      setFilterData((prevState) => {
        const newState = { ...prevState };
        delete newState[type];
        return newState;
      });
    } else {
      setFilterData((pre) => ({ ...pre, [type]: e }));
    }
  };
  const handleApplyFilters = () => {
    if (Object.keys(filterData ?? {})?.length > 0 || (Object.keys(filterData ?? {})?.length === 0 && Object.keys(filtersData ?? {})?.length > 0)) {
      onSearch(filterData);
      handleClose();
    } else {
      notification.warning({ message: 'At least one filter is required', placement: 'bottomRight' });
    }
  };
  return (
    <div style={{ width: '100%', marginTop: '1rem', marginBottom: '0.75rem' }}>
      <Form layout='vertical'>
        <div className='custom-child'>
          <div className='-mt-[8px]'>
            <Form.Item name='date' className='modalField font-bold' label='Date Range:'>
              <DateRangePicker
                defaultValue={filtersData?.date_range ? [moment(filtersData?.date_range[0]), moment(filtersData?.date_range[1])] : null}
                value={[filterData?.date_range]}
                hideButton={true}
                onChange={(e) => handleOnChangeValue(e, 'date_range')}
              />
            </Form.Item>
          </div>
        </div>
        <div className='binClass mt-1'>
          <div className='float-start filter-btn'>
            <Button
              onClick={() => {
                handleApplyFilters();
                filterToggler();
              }}>
              Apply
            </Button>
          </div>
        </div>
      </Form>
    </div>
  );
};

export default Filter;
